import request from '@/utils/request'

let NeedAPi = {
  creditIndex(data, errorback) {
    return request._get('/shop/need.credit/index', data, errorback);
  },
  creditAll(data, errorback) {
    return request._get('/shop/need.credit/getAll', data, errorback);
  },
  getCreditEdit(data, errorback) {
    return request._get('/shop/need.credit/edit', data, errorback);
  },
  setCreditEdit(data, errorback) {
    return request._post('/shop/need.credit/edit', data, errorback);
  },
  creditAdd(data, errorback) {
    return request._post('/shop/need.credit/add', data, errorback);
  },
  creditDelete(data, errorback) {
    return request._post('/shop/need.credit/delete', data, errorback);
  },


  businessIndex(data, errorback) {
    return request._get('/shop/need.business/index', data, errorback);
  },
  businessAll(data, errorback) {
    return request._get('/shop/need.business/getAll', data, errorback);
  },
  getBusinessEdit(data, errorback) {
    return request._get('/shop/need.business/edit', data, errorback);
  },
  setBusinessEdit(data, errorback) {
    return request._post('/shop/need.business/edit', data, errorback);
  },
  businessAdd(data, errorback) {
    return request._post('/shop/need.business/add', data, errorback);
  },
  businessDelete(data, errorback) {
    return request._post('/shop/need.business/delete', data, errorback);
  },


  needIndex(data, errorback) {
    return request._get('/shop/need.need/index', data, errorback);
  },
  needDetail(data, errorback) {
    return request._get('/shop/need.need/detail', data, errorback);
  },
  cityAll(data, errorback) {
    return request._get('/shop/city.city/getAll', data, errorback);
  },
  needEdit(data, errorback) {
    return request._post('/shop/need.need/edit', data, errorback);
  },
  needDelete(data, errorback) {
    return request._post('/shop/need.need/delete', data, errorback);
  },
  needStatus(data, errorback) {
    return request._post('/shop/need.need/status', data, errorback);
  },

}
export default NeedAPi;



// WEBPACK FOOTER //
// ./src/api/need.js